module.exports = __webpack_public_path__ + "img/bgfaq.1635ba1d.jpg";